import "../../MainBox/MainBox.css";

export default function DisabledAccordUS() {
  
    return (
        <div className="accordion">
            <div className="accordion-item">
                <div className="accordion-header">
                    Notes
                </div>
                <div className="accordion-content accordian-border">
                </div>
            </div>
            <div className="accordion-item">
                <div className="accordion-header">
                    Forecast & Shipments
                </div>
                <div className="accordion-content accordian-border">
                </div>
            </div>

            <div className="accordion-item">
                <div className="accordion-header">
                    Stock Overview
                </div>
                <div className="accordion-content accordian-border">
                </div>
            </div>

            <div className="accordion-item">
                <div className="accordion-header">
                    POS Demand
                </div>
                <div className="accordion-content accordian-border">
                </div>
            </div>

            <div className="accordion-item">
                <div className="accordion-header">
                    Reprint Inputs
                </div>
                <div className="accordion-content accordian-border">
                </div>
            </div>
            <div className="accordion-item">
                <div className="accordion-header">
                    Components on Hand
                </div>
                <div className="accordion-content accordian-border">
                </div>
            </div>
            <div className="accordion-item">
                <div className="accordion-header">
                 Production Specs
                </div>
                <div className="accordion-content accordian-border">
                </div>
            </div>
            <div className="accordion-item">
                <div className="accordion-header">
                    Series Data
                </div>
                <div className="accordion-content accordian-border">
                </div>
            </div>
            <div className="accordion-item">
                <div className="accordion-header">
                    Title Family & Packs
                </div>
                <div className="accordion-content accordian-border">
                </div>
            </div>
            <div className="accordion-item">
                <div className="accordion-header">
                    Marketing & Publicity
                </div>
                <div className="accordion-content accordian-border">
                </div>
            </div>
        </div>
    );
}